import React, { useEffec, useStatet } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import {
  BtnClose, Dialog
  , DialogContent, DialogTitle, NoticeDetail, NoticeItem, Overlay
  , TextTile
} from './styles'
import dayjs from 'dayjs';

const NoticeModal = ({ noticeList, handleDialogClose, noticeDetail, handleClick }) => {
  const cleanMessage = noticeDetail?.MessageBody?.replace(/\\n/g, '\n').replace(/\\t/g, '    ');
  const lines = cleanMessage ? cleanMessage.split('\n') : [];
  return (
    <>
      <Dialog>
        <DialogTitle>
          <TextTile>{noticeDetail?.MessageTitle || 'お知らせ一覧'}</TextTile>
          <BtnClose onClick={() => { handleDialogClose(); }}><FontAwesomeIcon icon={faXmark} /></BtnClose>
        </DialogTitle>
        <DialogContent>
          {/* Notice Items */}
          {!noticeDetail && noticeList?.length > 0 && (<>
            {noticeList.map((notice, idx) => {
              return (
                <NoticeItem key={`notice-${idx}`} onClick={() => handleClick(notice)}>
                  {/* Icon */}
                  <div className={`icon-box icon-success ${notice.IsSeen > 0 ? 'is-seen' : ''}`}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                      <polyline points="3.29 7 12 12 20.71 7"></polyline>
                      <line x1="12" y1="22" x2="12" y2="12"></line>
                    </svg>
                  </div>
                  <div className="notice-content">
                    <div className="notice-time">{dayjs(notice.DateToSend).format('YYYY/MM/DD HH:mm:ss')} {notice.IsSeen > 0 ? '既読' : '未読'}</div>
                    <div className="notice-title">{notice.MessageTitle}</div>
                  </div>
                  <div className="chevron">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </div>
                </NoticeItem>
              )
            })}
          </>)}

          {/* Notice Detail */}
          {!!noticeDetail && (
            <NoticeDetail >
              <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '0' }}>{noticeDetail.MessageTitle}</h2>
              <p style={{ fontSize: '12px', color: '#989ea8ff', marginBottom: '4px', marginTop: '2px' }}>{dayjs(noticeDetail.DateToSend).format('YYYY/MM/DD HH:mm:ss')}</p>
              <div className="detail-box">
                {lines.map((line, idx) => (
                  <p key={`line-${idx}`} style={{ fontSize: '14px', margin: '0', lineHeight: '20px' }}>{line}</p>
                ))}
              </div>
              <div className="modal-footer">
                <button className="btn-primary" onClick={() => { handleDialogClose(); }}>閉じる</button>
              </div>
            </NoticeDetail>
          )}
        </DialogContent>
      </Dialog>
      <Overlay /></>
  )
}


export default NoticeModal;
